import styled from 'styled-components';

export const ProjectBased = styled.article`
  max-width: 400px;
  min-width: 300px;
  display: grid;
  grid-template-rows: 30px 1fr;
  justify-content: center;
  justify-items: center;
  align-items: center;
  background: transparent;
  overflow: hidden;
  margin: 0 20px;
  position: relative;

  figure {
    max-width: 400px;
    min-width: 275px;
  }
`;
